import { graphql } from '@/gql';
import type { UpdateLocalTaxiPartnerRideMutation, UpdateLocalTaxiPartnerRideMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type UpdateLocalTaxiPartnerRideInput = UpdateLocalTaxiPartnerRideMutationVariables;

export type UpdateLocalTaxiPartnerRideOutput = UpdateLocalTaxiPartnerRideMutation['updateLocalTaxiPartnerRide'];

export const updateLocalTaxiPartnerRide = async ({ data }: UpdateLocalTaxiPartnerRideInput): Promise<UpdateLocalTaxiPartnerRideOutput> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation updateLocalTaxiPartnerRide($data: UpdateLocalTaxiPartnerRideInput!) {
        updateLocalTaxiPartnerRide(data: $data) {
          id
        }
      }
    `),
    variables: {
      data,
    },
  });

  return response.data!.updateLocalTaxiPartnerRide;
};
